export default __webpack_public_path__ + "static/media/Levelup.13340eff.mp3";